<template>
  <div id="page">
    <b-container>
      <!-- 模型 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>DIY即时制卡.模型</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toDemo()"
              >DIY即时制卡.模型</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 中原银行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>中原银行信用卡</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="zyBank()"
              >中原银行信用卡DIY卡</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 合肥通 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>合肥通定制DIY卡</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toHeFei()"
              >合肥通定制DIY卡</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 中国建设银行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>中国建设银行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="中国建设银行（三级运行商）判断标识:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="identification_ccb"
            required
            placeholder="判别标识"
            disabled
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="支付价格:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="pricelog_ccb"
            required
            placeholder="价格"
            disabled
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="app标识:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="applog_ccb"
            required
            placeholder="app标识"
            disabled
          ></b-form-input>
        </b-form-group>
        <div class="box">
          <b-col class="mx-auto">
            <b-button block variant="primary" @click="toCCB()"
              >中国建设银行</b-button
            >
          </b-col>
        </div>
        <!-- <hr /> -->
        <!-- <div class="box">
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toNingBo()"
              >进度查询</b-button
            >
          </b-col>
        </div> -->
      </div>
      <!-- 宁波公交 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>宁波公交</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="宁波公交（三级运行商）判断标识:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="identification"
            required
            placeholder="判别标识"
            disabled
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="支付价格:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="pricelog"
            required
            placeholder="价格"
            disabled
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="app标识:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="applog"
            required
            placeholder="app标识"
            disabled
          ></b-form-input>
        </b-form-group>
        <div class="box">
          <b-col class="mx-auto">
            <b-button block variant="primary" @click="toNingBoGongJiao()"
              >宁波公交</b-button
            >
          </b-col>
        </div>
        <!-- <hr /> -->
        <!-- <div class="box">
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toNingBo()"
              >进度查询</b-button
            >
          </b-col>
        </div> -->
      </div>
      <!-- 泰州公交DIY -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>泰州一卡通</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toTaizhou()"
              >泰州一卡通</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 洪城通DIY公交卡 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>洪城通DIY公交卡</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toHongChengTong()"
              >洪城通DIY公交卡</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 郑州一卡通定制DIY卡 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>郑州一卡通</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toZhengZhou()"
              >郑州一卡通</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 襄阳公交定制DIY卡 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>襄阳公交定制DIY卡</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toXiangyang()"
              >襄阳公交定制DIY卡</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 襄阳公交App定制DIY卡 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>襄阳公交App定制DIY卡</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toXiangyangApp()"
              >襄阳公交App定制DIY卡</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 四川中行 -->
      <div
        v-show="false"
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>四川中行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="银行唯一序列号:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankSerialNumber"
            required
            placeholder="银行唯一序列号"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="银行编号:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="bankCode"
            required
            placeholder="银行编号"
          ></b-form-input>
        </b-form-group>

        <div class="box">
          <b-button variant="outline-primary" @click="toSelectCard()"
            >DIY卡面</b-button
          >
          <b-button variant="outline-primary" @click="toQuery()"
            >查询进度</b-button
          >
        </div>
      </div>
      <!-- 徽商银行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>徽商银行</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toHsBank()"
              >徽商银行</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- 徽商手机银行App -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>徽商手机银行App</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toHsBankApp()"
              >徽商手机银行DIY</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- 乌鲁木齐商行 -->
      <div
        v-show="false"
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>乌鲁木齐商行</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toWlmqShBank()"
              >乌鲁木齐商行</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- 湖南银行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>湖南银行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="全局业务流水号:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankSerialNumber"
            required
            placeholder="全局业务流水号"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="是否为修改图片（1：申请，2：修改）"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="modifyPicture"
            required
            placeholder="是否为修改图片（1：申请，2：修改）"
          ></b-form-input>
        </b-form-group>
        <div class="box">
          <b-button variant="outline-primary" @click="tohunanbank()"
            >湖南银行</b-button
          >
          <!-- <b-button variant="outline-primary" @click="toQuery()"
            >查询进度</b-button
          > -->
        </div>
      </div>
      <!-- 齐鲁银行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>齐鲁银行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="银行唯一序列号:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankQiluNumber"
            required
            placeholder="银行唯一序列号"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="申请人姓名:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankQiluName"
            required
            placeholder="申请人姓名"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="是否可申请/查询:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="qiluDisable"
            required
            placeholder="是否可申请/查询"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="电话号码:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="qiluPhone"
            required
            placeholder="电话号码"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="身份证号码:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="bankQiluidCard"
            required
            placeholder="身份证号码"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="银行编号:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="bankCodeQilu"
            required
            :disabled="true"
            placeholder="银行编号"
          ></b-form-input>
        </b-form-group>

        <div class="box">
          <b-button variant="outline-primary" @click="toQlBank()"
            >DIY卡面</b-button
          >
          <b-button variant="outline-primary" @click="toQlBankQuery()"
            >查询进度</b-button
          >
        </div>
      </div>
      <!-- 齐商银行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>齐商银行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="银行唯一序列号:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankQishangNumber"
            required
            placeholder="银行唯一序列号"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="申请人姓名:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankQishangName"
            required
            placeholder="申请人姓名"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="是否可申请/查询:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="qishangDisable"
            required
            placeholder="是否可申请/查询"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="电话号码:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="qishangPhone"
            required
            placeholder="电话号码"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="身份证号码:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="bankQishangidCard"
            required
            placeholder="身份证号码"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="银行编号:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="bankCodeQishang"
            required
            :disabled="true"
            placeholder="银行编号"
          ></b-form-input>
        </b-form-group>

        <div class="box">
          <b-button variant="outline-primary" @click="toQsBank()"
            >DIY卡面</b-button
          >
          <b-button variant="outline-primary" @click="toQsBankQuery()"
            >查询进度</b-button
          >
        </div>
      </div>
      <!-- 青岛农商银行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>青岛农商银行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="行内流水号:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="serialNumber"
            required
            placeholder="银行唯一序列号"
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="网点编号:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="branchNo"
            required
            placeholder="网点编号"
          ></b-form-input>
        </b-form-group>
        <div class="box">
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toqingdaonshBank()"
              >青岛农商银行DIY卡面</b-button
            >
            <!-- <b-button block variant="primary" @click="getZFB_H5_Appid()"
              >跳转微信小程序(test)</b-button
            > -->
          </b-col>

          <!-- <b-button variant="outline-primary" @click="toqingdaonshBankQuery()"
            >查询进度</b-button
          > -->
        </div>
      </div>
      <!-- 深圳农商行 -->
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>深圳农商行</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toshenzhennshBank()"
              >深圳农商行</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- 迪拜及时制卡系统DIY -->
      <div
        v-show="false"
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>迪拜及时制卡系统</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toDubaiCard()"
              >迪拜及时制卡定制DIY卡</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
      <!-- 四川绵阳商行 -->
      <div
        v-show="false"
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>四川绵阳商行</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toSchmyshBank()"
              >四川绵阳商行</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- 四川天府银行 -->
      <div
        v-show="false"
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>四川天府银行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="银行唯一序列号:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankSerialNumber_schtnf"
            required
            placeholder="银行唯一序列号"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="银行编号:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="bankCode_schtnf"
            required
            placeholder="银行编号"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="操作类型:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="type_schtnf"
            required
            placeholder="操作类型(0- 第一次上传  1-重新上传  2-补卡)"
          ></b-form-input>
        </b-form-group>

        <div class="box">
          <b-button variant="outline-primary" @click="apply_schtnf()"
            >DIY卡面</b-button
          >
          <b-button variant="outline-primary" @click="query_schtnf()"
            >查询进度</b-button
          >
        </div>
      </div>
      <!-- 陕西信合 -->
      <div
        v-show="false"
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>陕西信合</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toShanxixinheBank()"
              >陕西信合</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- 泸州银行 -->
      <!-- <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>泸州银行</b></h6>
        <hr />
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-button block variant="primary" @click="toLuZhouBank()"
              >泸州银行DIY卡</b-button
            >
          </b-col>
        </b-row>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div> -->
      <div>
        <b-modal ref="model_error" title="提示" ok-title="确定" ok-only>
          <p>{{ errorMsg }}</p>
        </b-modal>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../common/config.js");
import { mobile_pattern } from "@/js/verifyData";
import wx from "weixin-js-sdk";
export default {
  name: "Home",
  data() {
    return {
      appid_aliH5: "",
      errorMsg: "",
      bankSerialNumber: "",
      modifyPicture: "", //是否为修改图片
      //齐鲁银行
      bankCode: "0001",
      bankQiluNumber: "", //齐鲁唯一银行序列号
      bankQiluName: "", //齐鲁银行申请人姓名
      bankCodeQilu: "01B1", //齐鲁银行编号
      bankQiluidCard: "", //齐鲁银行身份证号码
      qiluDisable: "0", //齐鲁银行是否可以查询/申请
      qiluPhone: "", //齐鲁电话号码输入
      //四川天府银行
      bankSerialNumber_schtnf: "", //四川天府银行流水号
      bankCode_schtnf: "01A2", //四川天府银行编号
      type_schtnf: 0,
      // 齐商银行
      bankQishangNumber: "", //齐商唯一银行序列号
      bankQishangName: "test", //齐商银行申请人姓名
      bankCodeQishang: "0085", //齐商银行编号
      bankQishangidCard: "", //齐商银行身份证号码
      qishangDisable: "0", //齐商银行是否可以查询/申请
      qishangPhone: "", //齐商电话号码输入
      bankCode_hunan: "0035", //湖南银行

      // 青岛农商银行
      serialNumber: "", //青岛农商银行流水号
      branchNo: "", //青岛农商银行网点编号

      // 宁波公交标识
      identification: "ningbo001",
      pricelog: "nb_a",
      applog: "gzh",
      identification_ccb: "0004",
      pricelog_ccb: "nb_a",
      applog_ccb: "gzh",
    };
  },
  mounted() {
    //console.log("this.$route", this.$route);
  },
  methods: {
    // 模型
    toDemo() {
      this.$router.push({
        name: "HomePage",
      });
    },
    // 中原银行
    zyBank() {
      //  data1:
      //     "d8eebbe3640d2f69c9eac2bc01c81b22a22d235771015ca1d91eddd4066db7df64f75ddc29222176430e92a9849bdd0a6a592ce48adc840b559c8d0312856917dce25c7b45a3f3a1ffefe94fd6fdc1a9266f5e22124930bba4df088e9cbb4fbf394128668b827933f0bb26ccb180d42f",
      //   data2:
      //     "047448fa1278092edc06ccc30bdd90c742d3cd3d88d7f3e6dde8888a88941bf9df9b6c47f54e57e639064ed120105e2cfbe22d39b98ba65366d85a191cec2989ff5f57d298954d3bf313e1f5b0caa5101eefa776c09ada1d2efd4f9ebdc0de9eb65994f3e354fce35f029d578b9cfef8a1",
      this.$router.push({
        name: "SelectCardface_zy",
        query: {
          data1:
            "d8eebbe3640d2f69c9eac2bc01c81b22a22d235771015ca1d91eddd4066db7df64f75ddc29222176430e92a9849bdd0a6a592ce48adc840b559c8d0312856917dce25c7b45a3f3a1ffefe94fd6fdc1a9266f5e22124930bba4df088e9cbb4fbf394128668b827933f0bb26ccb180d42f",
          data2:
            "047448fa1278092edc06ccc30bdd90c742d3cd3d88d7f3e6dde8888a88941bf9df9b6c47f54e57e639064ed120105e2cfbe22d39b98ba65366d85a191cec2989ff5f57d298954d3bf313e1f5b0caa5101eefa776c09ada1d2efd4f9ebdc0de9eb65994f3e354fce35f029d578b9cfef8a1",
        },
      });
    },
    // 合肥通
    toHeFei() {
      this.$router.push({
        name: "Home_hf",
      });
    },
    //中国建设银行
    toCCB() {
      this.$router.push({
        name: "home_ccb",
        query: {
          identification: this.identification_ccb,
          pricelog: this.pricelog_ccb,
          applog: this.applog_ccb,
        },
      });
    },
    // 宁波公交
    toNingBoGongJiao() {
      this.$router.push({
        name: "home_ningbo",
        query: {
          identification: this.identification,
          pricelog: this.pricelog,
          applog: this.applog,
        },
      });
    },
    toNingBo() {
      this.$router.push({
        name: "queryOrder_ningbo",
        query: {
          identification: this.identification,
          pricelog: this.pricelog,
          applog: this.applog,
        },
      });
    },
    //泰州公交DIY
    toTaizhou() {
      this.$router.push({
        name: "Home_tai",
        query: {},
      });
    },
    tohunanbank() {
      this.$router.push({
        name: "BaseApplyAction",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode_hunan,
          modifyPicture: this.modifyPicture,
        },
      });
    },
    toSelectCard: function () {
      this.$router.push({
        name: "BaseApplyAction",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
        },
      });
    },
    toQuery: function () {
      this.$router.push({
        name: "BaseQueryAction",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
        },
      });
    },
    toHsBank: function () {
      this.$router.push({
        name: "Home_hs",
      });
    },
    toHsBankApp: function () {
      this.$router.push({
        name: "Home_app_hs",
        query: {},
      });
    },
    toXiangyangApp() {
      this.$router.push({
        name: "Home_app_xy",
        query: {},
      });
    },
    toHongChengTong() {
      this.$router.push({
        name: "Home_hongcheng",
        query: {},
      });
    },
    //齐鲁银行制卡
    toQlBank: function () {
      var temp;
      let dataList = {
        checkStatus: this.qiluDisable, ////齐鲁银行是否可以查询/申请
        flowNo: this.bankQiluNumber, //齐鲁唯一银行序列号
        merchNo: "01B1", //银行编号
        mobileNo: this.qiluPhone, //手机号
        name: this.bankQiluName, //齐鲁银行申请人姓名
        idCard: this.bankQiluidCard, //身份证号
      };

      let passed = this.checkQlorQsParam(dataList);
      if (!passed) {
        this.showErrorMsg();
        return;
      }

      axios({
        method: "post",
        url: config.config_ql.getEncryptData,
        data: dataList,
      }).then((res) => {
        temp = res.data;
        this.$router.push({
          name: "BaseApplyAction_ql", //SelectCardface_ql
          query: {
            applyDetail: temp,
            bankCode: this.bankCodeQilu,
            isInner: "inner",
          },
        });
      });
    },
    //齐鲁银行查询进度
    toQlBankQuery: function () {
      var temp;
      let dataList = {
        checkStatus: this.qiluDisable,
        flowNo: this.bankQiluNumber,
        merchNo: "01B1",
        mobileNo: this.qiluPhone,
        name: this.bankQiluName,
        idCard: this.bankQiluidCard,
      };
      axios({
        method: "post",
        url: config.config_ql.getEncryptData,
        data: dataList,
      }).then((res) => {
        temp = res.data;
        this.$router.push({
          name: "BaseQueryAction_ql", //OrderList_ql
          query: {
            applyDetail: temp,
            bankCode: this.bankCodeQilu,
            isInner: "inner",
          },
        });
      });
    },
    //齐商银行制卡
    toQsBank: function () {
      var temp;
      let dataList = {
        checkStatus: this.qishangDisable,
        flowNo: this.bankQishangNumber,
        merchNo: this.bankCodeQishang,
        mobileNo: this.qishangPhone,
        name: this.bankQishangName,
        idCard: this.bankQishangidCard,
      };

      let passed = this.checkQlorQsParam(dataList);
      if (!passed) {
        this.showErrorMsg();
        return;
      }

      axios({
        method: "post",
        url: config.config_qs.getEncryptData,
        data: dataList,
      }).then((res) => {
        console.log("res->" + JSON.stringify(res));
        temp = res.data;
        console.log("temp->" + JSON.stringify(temp));
        this.$router.push({
          name: "BaseApplyAction_qs", //SelectCardface_qs
          query: {
            applyDetail: temp,
            bankCode: this.bankCodeQishang,
            isInner: "inner",
          },
        });
      });
    },
    //齐商银行查询进度
    toQsBankQuery: function () {
      var temp;
      let dataList = {
        checkStatus: this.qishangDisable,
        flowNo: this.bankQishangNumber,
        merchNo: this.bankCodeQishang,
        mobileNo: this.qishangPhone,
        name: this.bankQishangName,
        idCard: this.bankQishangidCard,
      };

      axios({
        method: "post",
        url: config.config_qs.getEncryptData,
        data: dataList,
      }).then((res) => {
        temp = res.data;
        this.$router.push({
          name: "BaseQueryAction_qs", //OrderList_qs
          query: {
            applyDetail: temp,
            bankCode: this.bankCodeQishang,
            isInner: "inner",
          },
        });
      });
    },
    toqingdaonshBank: function () {
      // 青岛农商银行
      this.$router.push({
        name: "SelectCardface_qingdao",
        query: {
          serialNumber: this.serialNumber, //青岛农商银行流水号
          branchNo: this.branchNo, //青岛农商银行网点编号
        },
      });
    },
    getZFB_H5_Appid() {
      let that = this;
      let bankCode = config.config_hs.bankCode;
      var formData = new FormData();
      formData.append("bankCode", bankCode);
      axios({
        method: "post",
        url: config.config_commonPay.initAilPay,
        data: formData,
      })
        .then(function (response) {
          console.log("response--->", response);
          var result = response.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          let data = result.data;
          that.appid_aliH5 = data.appid;
        })
        .catch(function (error) {
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    toWX() {
      // 青岛农商银行支付微信小程序
      console.log("微信小程序");
      wx.miniProgram.redirectTo({ url: "/pages/qingdao_wxPay/index" });
    },
    toWX() {
      wx.miniProgram.launchMiniProgram({
        appId: "wx4c1c386a871ab553", // 替换为你的小程序AppID
        path: "/pages/qingdao_wxPay/index", // 替换为你小程序中想要打开的页面路径
        success(res) {
          // 打开成功
          console.log("成功打开小程序", res);
        },
        fail(err) {
          // 打开失败
          console.error("打开小程序失败", err);
        },
      });
    },
    get() {
      var url = window.location.href.split("#")[0];
      var type = "0";
      var bankCode = "default";
      var formData = new FormData();
      formData.append("shareUrl", url);
      formData.append("type", type);
      formData.append("bankCode", bankCode);
      axios({
        method: "post",
        url: "https://ts.hengbao.net.cn/pay/order/wx/initWXJSSDKConfigInfo",
        data: formData,
      })
        .then(function (response) {
          var result = response.data;
          // if (result.code != 0) {
          //   //失败
          //   that.errorMsg = "获取appID失败";
          //   that.showErrorMsg();
          //   return;
          // }
          that.initWXJSSDKConfigInfo = JSON.stringify(response);
          var data = response.data;
          console.log(data.appid);
          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    toWlmqShBank: function () {
      //乌鲁木齐商行
      this.$router.push({
        name: "SelectCardface_wlmqsh",
      });
    },

    toshenzhennshBank: function () {
      //深圳农商行
      this.$router.push({
        name: "Home_shzhnsh",
      });
    },
    toSchmyshBank: function () {
      //四川绵阳商行
      this.$router.push({
        name: "Home_schmysh",
      });
    },
    toShanxixinheBank() {
      //陕西信合
      // this.$router.push({
      //   name: "Home_shxxh"
      // });
    },
    apply_schtnf: function () {
      //四川天府银行申请卡面
      this.$router.push({
        name: "BaseApplyAction",
        query: {
          bankSerialNumber: this.bankSerialNumber_schtnf,
          bankCode: this.bankCode_schtnf,
          type: this.type_schtnf,
        },
      });
    },
    query_schtnf: function () {
      this.$router.push({
        name: "BaseQueryAction",
        query: {
          bankSerialNumber: this.bankSerialNumber_schtnf,
          bankCode: this.bankCode_schtnf,
        },
      });
    },
    toXiangyang: function () {
      // 襄阳公交定制DIY卡
      this.$router.push({
        name: "Home_xy",
      });
    },
    toZhengZhou: function () {
      // 郑州一卡通定制DIY卡
      this.$router.push({
        name: "Home_zz",
      });
    },
    toDubaiCard: function () {
      // 迪拜及时制卡系统
      this.$router.push({
        name: "Home_Dubai",
      });
    },
    toLuZhouBank: function () {
      // 泸州银行定制DIY卡
      this.$router.push({
        name: "SelectCardface_luzh",
      });
    },
    checkQlorQsParam: function (param) {
      //检查齐鲁或齐商的参数
      const pattMobile = mobile_pattern;

      let passed = false;
      if (param == null || param == undefined) {
        this.errorMsg = "输入参数有误";
      } else if (param.flowNo == null || param.flowNo.trim().length == 0) {
        this.errorMsg = "请输入银行唯一序列号";
      } else if (param.mobileNo == null || !pattMobile.test(param.mobileNo)) {
        this.errorMsg = "请输入正确的手机号";
      } else if (
        param.name == null ||
        param.name.length == 0 ||
        param.name.length < 2 ||
        param.name.length > 15
      ) {
        this.errorMsg = "您输入的姓名长度不符合要求，请重新输入";
      } else {
        passed = true;
      }
      return passed;
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
  },
};
</script>

<style scoped>
.lefttext {
  text-align: left;
}

.box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue